// selecting the element
let items = document.querySelectorAll('.card-id');

for (let i = 0; i < items.length; i++) {
  // Add class to the element
  items[i].addEventListener('click', function() {
    items[i].classList.toggle('active');
  });
}

let tabs = document.querySelectorAll('.s-afiliados__list-item');

for (let i = 0; i < tabs.length; i++) {
  // Add class to the element
  tabs[i].addEventListener('click', function() {
    let item = document.querySelector('.s-afiliados__list-item');
    let siblings = item.parentNode.querySelectorAll(':scope > :not(.s-afiliados__list-item)');
    for (let z = 0; z < siblings.length; z++) {
        siblings[z].classList.remove('active');
    }
    tabs[i].classList.add('active');
  });
}

function openTabs(evt) {
  evt.preventDefault();
  var i, tabcontent;
  tabcontent = document.querySelectorAll('.s-afiliados__list-item');
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].classList.remove("active");
  }
  evt.currentTarget.classList.add('active');
}

function openTabsGuide(evt) {
  evt.preventDefault();
  // Find the closest tablist context so multiple size-chart instances don't conflict
  var tablist = evt.currentTarget.closest('.size-chart__list') || document;
  var tabcontent = tablist.querySelectorAll('.size-chart__list-item');
  for (var i = 0; i < tabcontent.length; i++) {
    tabcontent[i].classList.remove('active');
    var btn = tabcontent[i].querySelector('button[role="tab"]');
    if (btn) btn.setAttribute('aria-selected', 'false');
  }
  var parentItem = evt.currentTarget.closest('.size-chart__list-item') || evt.currentTarget;
  parentItem.classList.add('active');
  evt.currentTarget.setAttribute && evt.currentTarget.setAttribute('aria-selected', 'true');
  // Toggle the actual tab content visibility (data-tabs attr)
  var unit = parentItem.dataset && parentItem.dataset.links;
  if (unit) {
    var root = parentItem.closest('.size-chart__inner') || parentItem.closest('.size-chart') || document;
    var panels = root.querySelectorAll('.size-chart__content');
    for (var p = 0; p < panels.length; p++) {
      panels[p].classList.toggle('size-chart__content--active', panels[p].dataset.tabs === unit);
    }
  }
}

// Keyboard nav for size-chart tabs (a11y)
document.addEventListener('keydown', function(e) {
  var tab = e.target.closest && e.target.closest('.size-chart__list button[role="tab"]');
  if (!tab) return;
  var keys = { 'ArrowRight': 1, 'ArrowLeft': -1, 'Home': 'home', 'End': 'end' };
  if (!(e.key in keys)) return;
  e.preventDefault();
  var tabs = Array.from(tab.closest('.size-chart__list').querySelectorAll('button[role="tab"]'));
  var idx = tabs.indexOf(tab);
  var newIdx;
  if (keys[e.key] === 'home') newIdx = 0;
  else if (keys[e.key] === 'end') newIdx = tabs.length - 1;
  else newIdx = (idx + keys[e.key] + tabs.length) % tabs.length;
  tabs[newIdx].focus();
  tabs[newIdx].click();
});

/* Change Image - Click variant */
/* -------------------------------------------------------------------------------------- */

function showImageVariant(event) {
  event.preventDefault();
  // null-safe: bail silently if v6 product card markup isn't present (v8 product-block has different structure)
  var card = event.currentTarget.closest(".block-inner-inner");
  if (!card) return;
  var imagenURL = event.currentTarget.dataset.background;
  if (!imagenURL) return;
  var imagenWrapper = card.querySelector('.c-product-card__image-color');
  if (!imagenWrapper) return;
  var imagen = document.createElement('img');
  imagen.className = 'c-product-card__image-variant-color';
  imagen.src = imagenURL;
  imagen.loading = 'lazy';
  imagen.alt = '';
  if (imagenWrapper.hasChildNodes()) {
    imagenWrapper.removeChild(imagenWrapper.firstElementChild);
  }
  imagenWrapper.appendChild(imagen);
  var imagenSlider = card.querySelectorAll('.product-block__image');
  imagenSlider.forEach(function (item, index) {
    if (index === 0) {
      item.classList.add('product-block__image--active');
    } else {
      item.classList.remove('product-block__image--active');
    }
  });
}